import { Headline } from '../../atoms';
import { Accordion } from '../../organisms/Accordion/Accordion';

const accordionData = [
  {
    title: 'Mit welchen Kosten kann ich für eine Cannabis-Therapie rechnen?',
    content: `Da es sich bei der Therapie um eine privatärztliche Leistung handelt, sind wir dazu verpflichtet nach der GOÄ (Gebührenordnung für Ärzte) abzurechnen. Unser Preismodell finden Sie auf unserer Website.`,
  },
  {
    title: 'Woher weiß ich, dass mein Termin bestätigt ist?',
    content: `Sobald Sie den Termin gebucht haben, sehen Sie die Bestätigung in der App auf dem Dashboard. Sie erhalten außerdem eine Bestätigungsemail mit allen wichtigen Informationen.`,
  },
  {
    title: 'Wie sage ich einen Termin ab? ',
    content: `Spätestens 24h vor dem Termin müssen Sie sich per Telefon, E-Mail oder Chat an uns wenden, um einen Termin abzusagen damit auch keine Ausfallgebühren veranlasst werden. Im Falle einer Störung unmittelbar bei Ihrem Termin müssen Sie sich sofort per Telefon, E-Mail oder Chat an uns wenden. `,
  },
  {
    title: 'Mein Präparat ist in der Apotheke nicht mehr verfügbar, was nun?',
    content: `Ihre Apotheke setzt sich mit Ihnen in Verbindung oder mit Ihrem Arzt. Die Apotheke kann in Rücksprache mit dem Arzt das Rezept abändern ohne das ein neues Rezept ausgestellt werden muss. Sollte Ihre Apotheke nicht bereit sein, diese Rücksprache vorzunehmen, müssen Sie ein neues Rezept bestellen. Am besten prüfen Sie vor Ihrer Apothekenwahl ob Ihre Wunschapotheke diesen Service anbietet.`,
  },
  {
    title: 'Auf welchem Weg erhalte ich meine Rechnung?',
    content: `Ihre Rechnung wird Ihnen auf dem Postweg von der ärztlichen Verrechnungsstelle Büdingen zugeschickt. Mit Eingang der Rechnung wird die Zahlung fällig. Begleichen Sie den Rechnungsbetrag unter Angabe des Verwendungszwecks (Rechnungsnummer).`,
  },
];

export function Faq(): JSX.Element {
  return (
    <div className='w-full'>
      <div className='mt-12 mb-20 max-w-4xl mx-auto px-4'>
        <div className='mb-8'>
          <Headline level={4} center={true}>
            Häufige Fragen
          </Headline>
        </div>
        <Accordion accordionData={accordionData} />
      </div>
    </div>
  );
}
